import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCouponDerivatives = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="m18.09 8.25-.653-2.045a.25.25 0 0 0-.314-.162l-6.89 2.207h7.858Zm-12.556 0a.747.747 0 0 1 .275-.158l10.856-3.477a1.75 1.75 0 0 1 2.2 1.133l.829 2.59A2.751 2.751 0 0 1 21.75 11v1.17a.75.75 0 0 1-.5.708 2.251 2.251 0 0 0 0 4.244c.3.106.5.39.5.707V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-1.17c0-.319.2-.602.5-.708a2.251 2.251 0 0 0 0-4.244.75.75 0 0 1-.5-.707V11A2.75 2.75 0 0 1 5 8.25h.534ZM3.75 11c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v.683a3.749 3.749 0 0 0 0 6.634V19c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-.683a3.75 3.75 0 0 0 0-6.634V11Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364ZM11.725 11.917a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.031.575 1.69a.29.29 0 0 1-.441.332L12 16.16l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.031a.29.29 0 0 1 .166-.53h1.85l.584-1.716Z"
    />
  </svg>
);
export default SvgTwoColorCouponDerivatives;
